import FixedBody from './FixedBody';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import FixedMenu from './FixedMenu';

const CommonExport = {
  FixedBody,
  ScrollToTopOnMount,
  FixedMenu
};

module.exports = CommonExport;



// WEBPACK FOOTER //
// ./src/ui/Common/index.js